import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { uiStore } from '../../core/stores/ui-store';
import { Header } from '../project/project.page';
import { Link, useParams } from 'react-router';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { TaskDetail } from '../../features/tasks/components/task-detail';
import { Task } from '../../app/entities';

import styles from './space-task.route.module.scss';
export const SpaceTaskRoute: React.FC = observer(() => {
  const { taskId } = useParams();
  const task = Task.getOne(taskId) as Task;

  useEffect(() => {
    uiStore.currentLocation = 'space.tasks';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  return (
    <div className={styles['container']}>
      <Header>
        <div className={styles['crumb']}>
          <Link className={styles['parent']} to="../">
            Tasks
          </Link>
          <ChevronRightIcon />
          {task.title}
        </div>
      </Header>

      <div className={styles['scroller']}>
        <TaskDetail task={task} />
      </div>
    </div>
  );
});
